// TODO: replace all hard-coded paths with `PATHS`
export const PATHS = {
	BASE: "/",
	MEMBER_SAVED: "/members/saved/",
	MEMBER_COLLECTIONS: "/members/collections/",
	MEMBER_NOTES: "/members/notes/",
	PLUS_ORGANIZATIONS: "/plus/organizations/",
};
